import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent extends SuperComponent implements OnInit, OnChanges {
  @Input() m: any;
  @Input() value: any = [];
  @Input() head: string;
  @Input() coulmn: {}[] = [];
  @Output() valueChange = new EventEmitter<any[]>();
  @Input() displayexpr: string = 'nameAr'; // ✅ default value
  @Input() selectionmode: string = 'multiple'; // ✅ default value
  
  errormessage = this.translate.instant('errors.required');
  
  constructor(translate: TranslateService, Objects: ObjectsService, gt: genericCustomStoreService) {
    super(Objects, translate, gt);
  }

  ngOnInit(): void {
    // ✅ Ensure value is always an array for multiple selection
    if (this.selectionmode === 'multiple' && !Array.isArray(this.value)) {
      this.value = this.value ? [this.value] : [];
    }
    console.log(' Initial value:', this.value);
    console.log(' Display expr:', this.displayexpr);
    console.log(' Selection mode:', this.selectionmode);
  }

  ngOnChanges(changes: SimpleChanges): void {
 
    if (changes['value'] && !changes['value'].firstChange) {
      console.log(' Value changed externally:', changes['value'].currentValue);
      
      if (this.selectionmode === 'multiple' && !Array.isArray(this.value)) {
        this.value = this.value ? [this.value] : [];
      }
    }
  }

  onSelectionChanged(newKeys: any[]): void {
    console.log(' Selection changed:', newKeys);
    
   
    this.value = Array.isArray(newKeys) ? [...newKeys] : [];
    

    this.valueChange.emit(this.value);
  }
}